
export default {
  SET_CURRENT_CAMPAIGN (state, campaign) {
    state.currentCampaign = campaign
  }
}
